const areas: Mapping[] = [
  {
    label: '北海道',
    value: 0,
  },
  {
    label: '東北',
    value: 1,
  },
  {
    label: '関東甲信',
    value: 2,
  },
  {
    label: '中部',
    value: 3,
  },
  {
    label: '近畿',
    value: 4,
  },
  {
    label: '中国',
    value: 5,
  },
  {
    label: '四国',
    value: 6,
  },
  {
    label: '九州・沖縄',
    value: 7,
  },
];
export default areas;
